import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ModalController, Platform } from '@ionic/angular';
import { DefaultModalComponent } from '../components/modals/default-modal/default-modal.component';
import { Installation } from '../models/Installation';
import * as moment from 'moment';
import { GlobalVariablesService } from './global-variables.service';
import { StorageService } from './commons/storage.service';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { Network } from '@capacitor/network';
import { FingerprintAccessComponent } from '../components/modals/fingerprint-access/fingerprint-access.component';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { environment } from '../../environments/environment';
import { Market } from '@ionic-native/market/ngx';
import { AnalyticsService } from './commons/analytics.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
const UNIQUE_DEVICE_ID = 'unique-device-id';
import { registerPlugin } from "@capacitor/core";
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { UserLogin } from '../models/UserLogin';
import { ChatComponent } from '../components/modals/chat/chat.component';
import { CardNew } from '../models/CardNew';
import { NewsPresentationComponent } from '../components/modals/news-presentation/news-presentation.component';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FormGroup } from '@angular/forms';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
const GeoPlugin = registerPlugin<any>('GeoPlugin');
const GeoPluginiOS = registerPlugin<any>('GeoPluginiOS');
@Injectable({
  providedIn: 'root'
})
export class GlobalMethodsService {

  private setupPage = new Subject<any>();
  private statusAlarm = new Subject<boolean>();
  private statusTimerPanel = new Subject<boolean>();
  private statusNewsPanel = new Subject<boolean>();
  private currentInstallation = new Subject<Installation>();
  private changeInstallation = new Subject<Installation>();
  private picNotif = new Subject<any>();
  private installationsList = new Subject<Installation[]>();
  private fullBackground = new Subject<boolean>();
  public moreComponent = new Subject<boolean>();
  public finishIntervalStatusInstallation = new Subject<void>();
  public startIntervalStatusInstallation = new Subject<void>();
  public finishCraChatStatus = new Subject<void>();
  public finishSupChatStatus = new Subject<void>();
  public startChatStatus = new Subject<void>();
  public closeWordOfDuressComponent = new Subject<void>();
  private hasConnection = new Subject<boolean>();
  public showLoading: boolean = false;
  public stopPtz$ = new Subject<void>();
  private statusNps = new Subject<string>();
  public finishIntervalCountDown$ = new Subject<Installation>();
  public msgLoading: string = '';
  public showLoadingBackground: boolean = false;

  //subject to trigger events 
  private openMaintenance: Subject<any> = new Subject<string>();
  private openHistorical: Subject<any> = new Subject<string>();
  private footerChatNotif: Subject<any> = new Subject<number>();
  private headerChatNotif: Subject<any> = new Subject<number>();


  //observable to listen to events 
  public openMaintenanceCall$: Observable<string> = this.openMaintenance.asObservable();
  public openHistoricalCall$: Observable<string> = this.openHistorical.asObservable();
  public footerChatNotifCall$: Observable<number> = this.footerChatNotif.asObservable();
  public headerChatNotifCall$: Observable<number> = this.headerChatNotif.asObservable();

  constructor(private router: Router,
    private modalController: ModalController,
    private translate: TranslateConfigService,
    public gvs: GlobalVariablesService,
    private zone: NgZone,
    private storage: StorageService,
    private faio: FingerprintAIO,
    private platform: Platform,
    private openNativeSettings: OpenNativeSettings,
    private market: Market,
    public analytics: AnalyticsService,
    private file: File,
    private diagnostic: Diagnostic
  ) {
    this.translate.initTranslate();
  }

  changeFooterChatNotif(pending: number) {
    this.footerChatNotif.next(pending);
  }

  changeHeaderChatNotif(pending: number) {
    this.headerChatNotif.next(pending);
  }

  openMaintenanceModal(notifData) {
    this.openMaintenance.next(notifData);
  }

  openHistoricalModal(notifData) {
    this.openHistorical.next(notifData);
  }

  /* Full Background
   ================================================== */
  public fullBackgroundEvent(): Subject<boolean> {
    return this.fullBackground;
  }

  public setFullBackground(status) {
    this.fullBackground.next(status);
  }

  /* Alarm
   ================================================== */
  public statusAlarmEvent(): Subject<boolean> {
    return this.statusAlarm;
  }

  public setStatusAlarm(status) {
    this.statusAlarm.next(status);
  }

  /* Timer Panel
  ================================================== */
  public statusTimerPanelEvent(): Subject<boolean> {
    return this.statusTimerPanel;
  }

  public setStatusTimerPanel(status) {
    this.statusTimerPanel.next(status);
  }

  /* News Panel
================================================== */
  public statusNewsPanelEvent(): Subject<boolean> {
    return this.statusNewsPanel;
  }

  public setStatusNewsPanel(status) {
    this.statusNewsPanel.next(status);
  }

  /* Setup page
   ================================================== */
  public setupPageEvent(): Subject<any> {
    return this.setupPage;
  }

  public setSetupPage(showHeader: boolean, showFooter: boolean, showSearcher: boolean, showNotificationPanel: boolean) {
    this.setupPage.next({ showHeader: showHeader, showFooter: showFooter, showSearcher: showSearcher, showNotificationPanel: showNotificationPanel });
  }

  /* Current installation event
   ================================================== */
  public installationEvent(): Subject<Installation> {
    return this.currentInstallation;
  }

  public setInstallationEvent(installation) {
    this.currentInstallation.next(installation);
  }

  /* Installations list event
 ================================================== */
  public installationListEvent(): Subject<Installation[]> {
    return this.installationsList;
  }

  public setInstallationListEvent(installations) {
    this.installationsList.next(installations);
  }

  /* Change installation event
 ================================================== */
  public changeInstallationEvent(): Subject<Installation> {
    return this.changeInstallation;
  }

  public setChangeInstallationEvent(installation) {
    this.changeInstallation.next(installation);
  }

  /* Open image notification event
================================================== */
  public picNotifEvent(): Subject<any> {
    return this.picNotif;
  }

  public setPicNotifEvent(notif) {
    this.picNotif.next(notif);
  }


  openUrl(url: string) {
    const slug = url.split(environment.URL_DEEPLINK).pop();
    if (slug.includes('recuperarpassword')) {
      this.router.navigateByUrl(slug);
    }
    if (slug.includes('crearusuario')) {
      this.router.navigateByUrl("/register" + slug);
    }
  }

  async openFailedProcessModal() {
    const title = await this.translate.getTranslate('MODAL.titleError');
    const text = await this.translate.getTranslate('MESSAGES.errorServer');
    const mainButton = await this.translate.getTranslate('BUTTON.agreed');
    const cssClass = 'modal-default';
    await this.openGenericModal(title, text, cssClass, mainButton);
  }

  async openGenericModal(title: string, text: string, cssClass: string, mainButton?: string, secondButton?: string, paramsAnalytics?: any): Promise<HTMLIonModalElement> {
    const modal = await this.modalController.create({
      component: DefaultModalComponent,
      cssClass,
      componentProps: {
        paramTitle: title,
        paramText: text,
        paramMainButton: mainButton,
        paramSecondButton: secondButton,
        paramsAnalytics
      }
    });
    await modal.present();
    return modal;
  }

  async loading(loadingText?) {
    const contentModal = await this.modalController.create({
      component: DefaultModalComponent,
      componentProps: {
        paramLoadingText: loadingText ? loadingText : ''
      },
      id: "loadSpinner",
      backdropDismiss: false,
      cssClass: ['modal-default', 'type-spinner'], // to open loading modal
    });

    contentModal.present().then();
  }

  parseDateMoment(date: string, format: string): Date {
    let dateFormat: Date = moment(date, format).toDate();
    return dateFormat;
  }

  dateFormat(date: Date, format: string): string {
    return moment(date).locale(this.gvs.lang).format(format);
  }

  replaceAt(word: string, index: number, replacement: string) {
    return word.substr(0, index) + replacement + word.substr(index + replacement.length);
  }

  async openSettingsDevice() {
    return new Promise(async (resolve, reject) => {
      const modal = await this.openGenericModal(await this.translate.getTranslate('MODAL.titleTouchID'), await this.translate.getTranslate('MESSAGES.touchIDDisabled'),
        'modal-default', await this.translate.getTranslate('BUTTON.settings'), await this.translate.getTranslate('BUTTON.cancel'));
      modal.onDidDismiss().then(res => {
        this.zone.run(async () => {
          if (res.data != null && res.data.result != null && res.data.result) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    });
  }

  /* Biometric Failed Modal
   ================================================== */
  async openFailedBiometricLoginModal() {
    const title = await this.translate.getTranslate('MODAL.titleError');
    const text = await this.translate.getTranslate('MESSAGES.fingerprintAuthNotCorrect');
    const mainButton = await this.translate.getTranslate('BUTTON.agreed');
    const cssClass = 'modal-default';
    return await this.openGenericModal(title, text, cssClass, mainButton);
  }

  async checkExpirationAuth(): Promise<boolean> {
    let expirationAuth: Date = await this.storage.getObject(this.gvs.EXPIRATION_AUTH);
    if ((expirationAuth == null) || (new Date(expirationAuth) < new Date())) {
      return false;
    } else {
      return true;
    }
  }

  /* Show/hide more component
 ================================================== */
  public statusMoreComponentEvent(): Subject<boolean> {
    return this.moreComponent;
  }

  public setMoreComponentEvent(value: boolean) {
    this.moreComponent.next(value);
  }

  hapticsImpact() {
    Haptics.impact({
      style: ImpactStyle.Light
    });
    Haptics.vibrate();
  }

  async futureVersion() {
    await this.openGenericModal("Información", "Versión futura", "modal-default", "Entendido");
  }

  async checkBiometricAuth(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.faio.show({
        title: await this.translate.getTranslate('MODAL.fingerprintAccess.title'), // (Android Only) | optional | Default: "<APP_NAME> Biometric Sign On"
        description: await this.translate.getTranslate('MODAL.fingerprintAccess.description'), // optional | Default: null
        fallbackButtonTitle: await this.translate.getTranslate('MODAL.fingerprintAccess.fallbackButtonTitle'), // optional | When disableBackup is false defaults to "Use Pin".
        disableBackup: false,  // optional | default: false
        cancelButtonTitle: await this.translate.getTranslate('BUTTON.cancel')
      })
        .then(async (result: any) => {
          resolve(result);
        })
        .catch(async (error: any) => {
          const message = JSON.stringify(error);
          await FirebaseCrashlytics.recordException({ message: message });
          resolve(error);
        });
    });
  }

  async checkPasswordAuth(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const modal = await this.modalController.create({
        component: FingerprintAccessComponent,
        componentProps: { type: 'password' },
        cssClass: ['w-modal-md'],
      });
      modal.onDidDismiss().then(result => {
        this.zone.run(async () => {
          resolve(result);
        });
      });

      await modal.present();
    });
  }

  async getCheckBiometricAuth(activeBiometric: boolean): Promise<boolean> {
    //let bioActive = await this.storage.getObject(this.gvs.SEE_TOUCHID);
    return new Promise(async (resolve, reject) => {
      if ((await this.platform.is('cordova')) && activeBiometric) {
        const result = await this.checkBiometricAuth();
        if (result === 'biometric_success' || result === 'Success') {
          resolve(true);
        }
        else if (result.code != null) {
          if (result.code === -106) {
            const response = await this.openSettingsDevice();
            if (response) {
              await this.openNativeSettings.open('settings');
              resolve(false);
            } else {
              const response = await this.getCheckPassAuth();
              if (response === false) {
                await this.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.checkPasswordAuthKo'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              resolve(response);
            }
            resolve(false);
          } else if (result.code === -102) {
            await this.openFailedBiometricLoginModal();
            resolve(false);
          } else if (result.code === -108) {
            resolve(false);
          } else {
            const response = await this.getCheckPassAuth();
            if (response === false) {
              await this.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.checkPasswordAuthKo'),
                'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
            }
            resolve(response);
          }
        } else {
          const response = await this.getCheckPassAuth();
          if (response === false) {
            await this.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.checkPasswordAuthKo'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
          resolve(response);
        }
      } else {
        const response = await this.getCheckPassAuth();
        if (response === false) {
          await this.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.checkPasswordAuthKo'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
        resolve(response);
      }
    });
  }

  async getCheckPassAuth(): Promise<boolean> {
    const resultCheckPassAuth: any = await this.checkPasswordAuth();
    return new Promise(async (resolve, reject) => {
      if (resultCheckPassAuth.data.confirm != null && resultCheckPassAuth.data.confirm && resultCheckPassAuth.data.result) {
        resolve(true);
      } else if (resultCheckPassAuth.data.confirm != null && resultCheckPassAuth.data.confirm && !resultCheckPassAuth.data.result) {
        resolve(false);
      } else {
        resolve(null);
      }
    });
  }

  async isAvailableAuthBio(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await this.faio.isAvailable().then(result => {
        if (result === 'biometric' || result === 'face' || result === 'finger') {
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch(async error => {
        const message = JSON.stringify(error);
        await FirebaseCrashlytics.recordException({ message: message });
        resolve(false);
      })
    });

  }

  /* Event clear interval status installation
   ================================================== */
  public clearIntervalStatusInstallationEvent() {
    this.finishIntervalStatusInstallation.next();
  }

  /* Event start interval status installation
 ================================================== */
  public startIntervalSatusInstallationEvent() {
    this.startIntervalStatusInstallation.next();
  }

  /* Event clear CRA chat status
 ================================================== */
  public clearCraChatStatusEvent() {
    this.finishCraChatStatus.next();
  }

  /* Event clear SUP chat status
 ================================================== */
  public clearSupChatStatusEvent() {
    this.finishSupChatStatus.next();
  }

  /* Event start chat status
 ================================================== */
  public startChatStatusEvent() {
    this.startChatStatus.next();
  }

  /* Event close word component
   ================================================== */
  public closeWordOfDuressComponentEvent() {
    this.closeWordOfDuressComponent.next();
  }

  /* Event stop ptz
    ================================================== */
  public stopPtzEvent() {
    this.stopPtz$.next();
  }

  /* Change nps event
    ================================================== */
  public getStatusNpsEvent(): Subject<string> {
    return this.statusNps;
  }

  public setStatusNpsEvent(status) {
    this.statusNps.next(status);
  }

  /* Check internet event
    ================================================== */

  async checkInternet(): Promise<boolean> {
    const statusNetwork = await Network.getStatus();
    if (statusNetwork.connected === false) {
      return false;
    } else {
      return true;
    }
  }

  /* Event finish countdown cybersafeguard
    ================================================== */
  public finishCountDownEvent(installation: Installation) {
    this.finishIntervalCountDown$.next(installation);
  }

  public networkStatusEvent(value: boolean) {
    return this.hasConnection.next(value);
  }

  public getNetworkStatusEvent(): Subject<boolean> {
    return this.hasConnection;
  }
  
  async networkStatusChange() {
    const handler = Network.addListener('networkStatusChange', async (status) => {
      if (status.connected === true) {
        this.networkStatusEvent(true);
      } else {
        this.networkStatusEvent(false);
      }
    });
  }

  goToAppStore(url: string) {
    if (this.platform.is('android')) {
      this.market.open(url.trim());
    } else if (this.platform.is('ios')) {
      this.market.open(url.trim());
    }
  }

  analyticsTrackEvent(label: string, data?) {
    let params = {};
    params = { ...params, ...data };
    this.analytics.logEvent(label, params);
  }

  analyticsTrackScreen(screenName: string) {
    this.analytics.trackScreen(screenName);
  }

  async clearSession(userLogin?: UserLogin) {
    await this.deleteGeofences();
    await this.storage.clear(userLogin);
    this.clearIntervalStatusInstallationEvent();
    window.clearInterval(this.gvs.cronTokenWeb);
    this.gvs.cronTokenWeb = 0;
  }

  async deleteGeofences() {
    if (await this.platform.is('android')) {
      this.gvs.activeGeofencesIDs.forEach(geofenceID => {
        GeoPlugin.removeGeofence({ geofenceID });
      });
    }
    else if (await this.platform.is('ios')) {
      this.gvs.activeGeofencesIDs.forEach(geofenceID => {
        GeoPluginiOS.removeGeofence({ geofenceID });
      });
    }
    this.gvs.activeGeofencesIDs = [];
  }

  setLoadingTrue(msg?: string, showBackground?: boolean) {
    this.showLoadingBackground = showBackground;
    this.msgLoading = msg != null && msg !== '' ? msg : '';
    this.showLoading = true;
  }

  setLoadingFalse() {
    this.showLoading = false;
  }

  public restDaysToDate(dateAsMs: number, days: number) {
    const adjustedTimeAsMs = dateAsMs - (1000 * 60 * 60 * 24 * days);
    return adjustedTimeAsMs;
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async checkRatingTime() {
    const installationDate = await this.storage.getObject('INSTALLATION_DATE');
    const today = new Date();
    if (!installationDate) {
      await this.storage.setObject('INSTALLATION_DATE', today);
      await this.addToDayCounter();
    } else {
      const lastUpdateCounter = await this.storage.getObject('LAST_COUNTER_UPDATE');
      if (today.getDate() != new Date(installationDate).getDate() && today.getDate() != new Date(lastUpdateCounter).getDate()) {
        await this.addToDayCounter();
      }
      const updatedCounter = await this.storage.getObject('USAGE_DAYS_COUNTER');
      const monthPassedCheck = await this.storage.getObject('MONTH_USAGE');
      const todayMs = new Date(today).getTime();
      if (updatedCounter === 5) {
        await this.storage.setObject('INSTALLATION_DATE', today);
        this.gvs.ratingAvailable = true;
      } else if (todayMs > this.addDaysToDate(new Date(installationDate).getTime(), 30) && !monthPassedCheck && updatedCounter > 5) {
        this.gvs.ratingAvailable = true;
        await this.storage.setObject('MONTH_USAGE', true);
      } else if (todayMs > this.addDaysToDate(new Date(installationDate).getTime(), 90) && updatedCounter > 5) {
        this.gvs.ratingAvailable = true;
      }
    }
  }

  public async addToDayCounter() {
    const daysCounter = await this.storage.getObject('USAGE_DAYS_COUNTER');
    if (!daysCounter) {
      await this.storage.setObject('USAGE_DAYS_COUNTER', 1);
    } else {
      await this.storage.setObject('USAGE_DAYS_COUNTER', (daysCounter + 1));
    }
    const today = new Date();
    await this.storage.setObject('LAST_COUNTER_UPDATE', today);
  }

  public addDaysToDate(dateAsMs: number, days: number) {
    const adjustedTimeAsMs = dateAsMs + (1000 * 60 * 60 * 24 * days);
    return adjustedTimeAsMs;
  }

  async initChat(user: string, chat_tp: number) {
    const contentModal = await this.modalController.create({
      component: ChatComponent,
      componentProps: {
        user: user,
        s_ins: this.gvs.currentInstallation.s_ins,
        chat_tp: chat_tp
      },
      cssClass: ['w-modal-lg', 'modal-chat'],
    });

    await contentModal.present();
    return contentModal;
  }

  async createDir(path: string, dirName: string): Promise<boolean>{
    return new Promise(async (resolve, reject) => {
      this.file.createDir(path, dirName, true).then((resp) => {
        resolve(true);
      })
      .catch((e) => {
        resolve(false);
      })
    });
  }

  checkDir(path: string, dir: string): Promise<boolean>{
    return new Promise(async (resolve, reject) => {
      this.file.checkDir(path, dir)
      .then((resp) => {
        resolve(true);
      })
      .catch((e) => {
        if(e.code != null && e.code === 1){
          resolve(false);
        }else{
          resolve(null);
        }
      })
    });
  }
  
    checkAllowedCharacters(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      if (typeof form.controls[key].value == "string" && key != "password" && key != "password_repeat") {
        let val = form.controls[key].value.toString();
        form.controls[key].setValue(val.replace(/"/g, "'"));
      }
    });
    return form;
  }

  async requestPermissionMicro(): Promise<boolean>{
    return new Promise(async (resolve, reject) => {
      let result = await this.diagnostic.isMicrophoneAuthorized();
      if(!result){
        await this.diagnostic.requestMicrophoneAuthorization().then(value => {
          if(value === 'GRANTED'){
            resolve(true);
          }else{
            resolve(false);
          }
        }
        ).catch(error => {
          resolve(false);
        });
      }else{
        resolve(true);
      }
    });
    
  }

  async checkPermissionMicro(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let statusPermission = await this.diagnostic.isMicrophoneAuthorized();
      resolve(statusPermission);
    });
  }

  validateCoords(data: any): boolean{
    return isFinite(data);
  }

  getUTCDate(date: Date): Date{
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getUTCHours(), date.getMinutes(), date.getSeconds(), 0);
  }

}
